<div class="us-dialog">

  <!-- Header -->
  <div class="us-header">
    <div class="us-title-wrap">
      <div class="us-title-icon">
        <mat-icon>group_add</mat-icon>
      </div>
      <div class="us-title-text">
        <h2 class="us-title">Assign people</h2>
        <div class="us-subtitle">Choose teams and users for this event</div>
      </div>
    </div>
    <button mat-icon-button mat-dialog-close class="us-close" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="us-body">
    <div class="us-col">
      <label class="us-label">Teams</label>
      <div class="us-picker">
        <app-team-select-multiple [displayTeamList]="true" [removableSelectionList]="true" [(teamIds)]="assignedTeamIds"></app-team-select-multiple>
      </div>
    </div>
    <div class="us-col">
      <label class="us-label">Users</label>
      <div class="us-picker">
        <app-user-select-multiple [displayUserList]="true" [removableSelectionList]="true" [(userIds)]="assignedUserIds"></app-user-select-multiple>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="us-footer">
    <button mat-button mat-dialog-close class="us-btn-ghost">Cancel</button>
    <button type="button" class="us-btn-primary" (click)="submit()">
      <span>Assign</span>
      <mat-icon>check</mat-icon>
    </button>
  </div>
</div>
